import { Component, Host, Prop, h, Element } from '@stencil/core';
@Component({
  tag: 'cms-blog-reference',
  styleUrl: 'cms-blog-reference.scss',
  shadow: false,
})
export class CmsBlogReference {
  /**
   * The original value of the display property of style  for the button.
   */
  @Prop() dataButtonDisplay: string = 'inline-block';

  /**
   * The original value of the display property of style  for the content.
   */
  @Prop() dataContentDisplay: string = 'block';

  @Element() elRoot: HTMLElement;

  connectedCallback() {
    this.elRoot.innerHTML = '';
  }

  componentDidLoad() {
    const articleBody: HTMLElement = document.querySelector('.article-body, #article-body');
    const articleReferenceElement: HTMLElement = document.querySelector('.article-reference');
    if (articleBody && articleReferenceElement) {
      const titleElement: HTMLElement = articleReferenceElement.previousElementSibling as HTMLElement;
      if (titleElement) {
        articleBody.appendChild(articleReferenceElement);
        const title = titleElement.innerText.replace(':', '');

        const newHtml: string = `	
            <cms-toggle class="cms-blog-reference"> 
            <div data-slot="open" style="width:100%;">${this.getTitleHtml(title, false)}</div>
            <div data-slot="close" style="display: none;width:100%;">${this.getTitleHtml(title, true)}</div>
            <div data-slot="content" style="display:none;">
                ${articleReferenceElement.outerHTML}
            </div>             
           </cms-toggle>`;
        articleReferenceElement.outerHTML = newHtml;
        titleElement.remove();
      }
    }
  }

  getTitleHtml = (title: string, isClose: boolean) => {
    return `<div class="cms-blog-reference-title ${isClose ? 'cms-toggle-close' : ''}">
    <p style="margin:0px;"><strong>${title}</strong></p>
    <cms-icon data-icon="angle-down" data-fill="#000" data-size="sm" ></cms-icon>
</div>`;
  };

  render() {
    return <Host />;
  }
}
